<template>
	<div class="childDiv2" id="page10" ref="mainEl" page="4">
		<img alt="" src="images/1x_images/section2/page4/keytech-light.png" srcset="images/2x_images/section2/page4/keytech-light.png 2x" class="absolute top-0 w-full h-full z-[10] pointer-events-none" ref="lightEl" />

		<div class="childWrapper">
			<div class="absolute w-full h-full top-0" ref="part1El">
				<img alt="" src="images/1x_images/section2/page4/text-keytech.png" srcset="images/2x_images/section2/page4/text-keytech.png 2x" class="relative top-[210px] left-[90px] z-[20]" />
				<img alt="" src="images/1x_images/section2/page4/btn-deepskin.png" srcset="images/2x_images/section2/page4/btn-deepskin.png 2x" class="button absolute top-[450px] left-[90px]" @click="popup()" />
				<img alt="" src="images/1x_images/section2/page4/btn-replay.png" srcset="images/2x_images/section2/page4/btn-replay.png 2x" class="button absolute top-[450px] left-[410px]" @click="replay(1)" />
				<img alt="" src="images/1x_images/section2/page4/text-keytech2.png" srcset="images/2x_images/section2/page4/text-keytech2.png 2x" class="absolute top-[946px] left-[90px]" />
				<div class="absolute top-[550px] center">
					<img alt="" src="images/1x_images/section2/page4/gel.png" srcset="images/2x_images/section2/page4/gel.png 2x" class="absolute center will-change-transform top-[19px]" ref="gelEl" />
					<div class="absolute top-[80px] overflow-hidden">
						<img alt="" src="images/1x_images/section2/page4/serum-penetration-epidermis1.png" srcset="images/2x_images/section2/page4/serum-penetration-epidermis1.png 2x" class="relative z-[10] will-change-transform" />
						<img alt="" src="images/1x_images/section2/page4/serum-penetration-epidermis2.png" srcset="images/2x_images/section2/page4/serum-penetration-epidermis2.png 2x" class="absolute top-0 z-[12] will-change-transform" />
						<img alt="" src="images/1x_images/section2/page4/serum-penetration-epidermis-bg.png" srcset="images/2x_images/section2/page4/serum-penetration-epidermis-bg.png 2x" class="absolute top-0 z-[8] will-change-transform" />
						<img alt="" src="images/1x_images/section2/page4/serum-penetration-bg.png" srcset="images/2x_images/section2/page4/serum-penetration-bg.png 2x" class="absolute top-0 center opacity-0 z-[9] will-change-transform" ref="gelBgEl" />
						<img alt="" src="images/1x_images/section2/page4/serum-penetration-bg2.png" srcset="images/2x_images/section2/page4/serum-penetration-bg2.png 2x" class="absolute top-0 center opacity-0 z-[11] will-change-transform" ref="gelBgEl2" />
					</div>
				</div>
			</div>

			<div class="absolute w-full h-full top-0" ref="part2El">
				<img alt="" src="images/1x_images/section2/page4/text-keytech4.png" srcset="images/2x_images/section2/page4/text-keytech4.png 2x" class="relative top-[210px] left-[90px] z-[20]" />
				<img alt="" src="images/1x_images/section2/page4/gel2.png" srcset="images/2x_images/section2/page4/gel2.png 2x" class="absolute top-[595px] left-[90px] center" ref="gel2El" />
				<img alt="" src="images/1x_images/section2/page4/epidermis2.png" srcset="images/2x_images/section2/page4/epidermis2.png 2x" class="absolute top-[630px] left-[90px] z-[9] center" ref="epidermis2El" />
				<img alt="" src="images/1x_images/section2/page4/epidermis2-smooth.png" srcset="images/2x_images/section2/page4/epidermis2-smooth.png 2x" class="absolute top-[630px] left-[90px] z-[9] center" ref="epidermis2SmoothEl" />
				<img alt="" src="images/1x_images/section2/page4/text-keytech3.png" srcset="images/2x_images/section2/page4/text-keytech3.png 2x" class="absolute top-[946px] left-[90px] z-[20]" />
				<img alt="" src="images/1x_images/section2/page4/btn-replay.png" srcset="images/2x_images/section2/page4/btn-replay.png 2x" class="button absolute top-[450px] left-[90px] z-[20]" @click="replay(2)" />

				<div class="absolute top-[665px] left-[90px] z-[10] center">
					<Dots class="absolute left-[440px] top-[10px]" ref="dot1El" />
					<Dots class="absolute left-[480px] top-[20px]" ref="dot2El" />
					<Dots class="absolute left-[510px] top-[60px]" ref="dot3El" />
					<Dots class="absolute left-[600px] top-[5px]" ref="dot4El" />
					<Dots class="absolute left-[680px] top-[20px]" ref="dot5El" />
				</div>
			</div>

			<div class="relative p-[5px] z-[20] w-[700px] h-[60px] top-[1140px] bg-[#d7e2f5] rounded-full flex justify-center items-center center">
				<div @click="activate(1)" class="rounded-l-full text-[23px] italic w-[50%] h-full font-thins flex justify-center items-center" :style="{ backgroundColor: active == 1 ? '#c2ad6c' : '' }">SELF-SPREADING FORMULATION</div>
				<div @click="activate(2)" class="rounded-r-full text-[23px] italic w-[50%] h-full font-thins flex justify-center items-center" :style="{ backgroundColor: active == 2 ? '#c2ad6c' : '' }">STABILIZING TECHNOLOGY</div>
			</div>
		</div>

		<!-- modal -->
		<div class="modal" ref="modalEl">
			<div class="childWrapper">
				<img alt="" class="button absolute top-[220px] center" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close()" />
				<div class="absolute top-[330px] w-fit center">
					<div class="bg-white w-[905px] h-[690px] rounded-[20px] pointer-events-none">
						<Timer ref="timerEl" class="absolute z-[10] top-[45px] left-[35px]" />
						<img class="absolute center top-[50px] z-[2]" alt="" src="images/1x_images/section2/page4/popup-serum-penetration.png" srcset="images/2x_images/section2/page4/popup-serum-penetration.png 2x" />
						<div class="relative w-fit h-fit top-[10px] bg-black rounded-[18px] overflow-hidden center">
							<!-- <img class="relative center" alt="" src="images/1x_images/section2/page4/stratum-corneum-before.png" srcset="images/2x_images/section2/page4/stratum-corneum-before.png 2x" ref="beforeImgEl" /> -->
							<img class="relative center" alt="" src="images/1x_images/section2/page4/stratum-corneum.png" srcset="images/2x_images/section2/page4/stratum-corneum.png 2x" ref="afterImgEl" />
						</div>
					</div>
					<div class="absolute w-[845px] h-fit bottom-[35px] center z-[10]">
						<DragBtn @trigger="updateImage" ref="dragBtnEl" class="z-[10]" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import DragBtn from "../../components/DragButton.vue";
import Dots from "../../components/Dots.vue";
import Timer from "../../components/Timer.vue";

export default {
	name: "page-1",
	components: { DragBtn, Dots, Timer },
	data() {
		return {
			active: 1,
		};
	},
	methods: {
		start() {
			this.animatePart1();
		},
		stop() {
			this.reset();
		},

		replay(type) {
			if (type == 1) {
				this.resetPart1();
				this.animatePart1();
			} else {
				this.resetPart2();
				this.animatePart2();
			}
		},
		updateImage(opacity) {
			// gsap.set(this.$refs.beforeImgEl, { autoAlpha: opacity });
			gsap.set(this.$refs.afterImgEl, { autoAlpha: opacity });
			this.$refs.timerEl.set(opacity);
		},
		popup() {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page2-menu", { autoAlpha: 0 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 1 });
		},
		close() {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page2-menu", { autoAlpha: 1 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
		},
		activate(type) {
			this.active = type;
			if (type == 1) {
				gsap.to(this.$refs.lightEl, { autoAlpha: 0, duration: 0.3, ease: "none", overwrite: true });
				gsap.to(this.$refs.part2El, { autoAlpha: 0, duration: 0.3, ease: "none" });
				// prettier-ignore
				gsap.to(this.$refs.part1El, { autoAlpha: 1, duration: 0.3, ease: "none", onComplete: () => {
					this.resetPart2();
					this.animatePart1();
				}});
			} else {
				// prettier-ignore
				gsap.to(this.$refs.part1El, { autoAlpha: 0, duration: 0.3, ease: "none", onComplete: () => {
					this.resetPart1();
					this.animatePart2();
				}});
				gsap.to(this.$refs.part2El, { autoAlpha: 1, duration: 0.3, ease: "none" });
			}
		},
		animatePart1() {
			gsap.to(this.$refs.gelEl, { scaleX: 1.1, scaleY: 0.8, y: 43, force3D: true, ease: "none", duration: 5 });
			gsap.to(this.$refs.gelBgEl, { autoAlpha: 1, scaleX: 2.4, scaleY: 1.3, y: 50, force3D: true, ease: "none", duration: 5 });
			gsap.to(this.$refs.gelBgEl2, { autoAlpha: 1, force3D: true, ease: "none", duration: 5 });
		},
		animatePart2() {
			this.contextPart2.add(() => {
				for (var i = 1; i <= 5; i++) {
					this.$refs[`dot${i}El`].fadeIn();
					this.$refs[`dot${i}El`].start();
				}
				gsap.delayedCall(0.5, () => {
					gsap.to(this.$refs.gel2El, { autoAlpha: 1, duration: 0.8, ease: "none", overwrite: true });
					gsap.to(this.$refs.lightEl, { autoAlpha: 1, duration: 0.8, ease: "none", overwrite: true });

					gsap.delayedCall(1.2, () => {
						for (var i = 1; i <= 5; i++) {
							this.$refs[`dot${i}El`].fadeOut();
						}
						gsap.to(this.$refs.epidermis2El, { autoAlpha: 0, duration: 3, ease: "in", overwrite: true });
						gsap.to(this.$refs.epidermis2SmoothEl, { autoAlpha: 1, duration: 3, ease: "out", overwrite: true });
					});
				});
			});
		},
		resetPart1() {
			gsap.set(this.$refs.gelEl, { scaleX: 1, scaleY: 1, y: 0, overwrite: true });
			gsap.set(this.$refs.gelBgEl, { autoAlpha: 0, scaleX: 1, scaleY: 1, y: 0, overwrite: true });
			gsap.set(this.$refs.gelBgEl2, { autoAlpha: 0, overwrite: true });
		},
		resetPart2() {
			for (var i = 1; i <= 5; i++) {
				this.$refs[`dot${i}El`].stop();
			}
			if (this.contextPart2) this.contextPart2.revert();
			gsap.set(this.$refs.gel2El, { autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.lightEl, { autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.epidermis2El, { autoAlpha: 1, overwrite: true });
			gsap.set(this.$refs.epidermis2SmoothEl, { autoAlpha: 0, overwrite: true });
		},
		reset() {
			gsap.set(".page2-menu", { autoAlpha: 1, overwrite: true });
			gsap.set(this.$refs.modalEl, { autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.part1El, { autoAlpha: 1, overwrite: true });
			gsap.set(this.$refs.part2El, { autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.afterImgEl, { autoAlpha: 0, overwrite: true });
			// gsap.set(this.$refs.beforeImgEl, { autoAlpha: 0, overwrite: true });

			this.resetPart1();
			this.resetPart2();
			this.$refs.dragBtnEl.reset();
			this.$refs.timerEl.reset();
			this.active = 1;
		},
	},
	mounted() {
		this.reset();
		this.contextPart2 = gsap.context(() => {}, this.$el); // Scope to the component's root element
		// setTimeout(() => {
		// 	this.start();
		// }, 500);
	},
};
</script>

<style></style>
